import React from 'react'
import PropTypes from 'prop-types'

const Step = (props) => {
  const {
    errorMessages,
    parts,
    submitButton
  } = props
  const {
    title,
    intro,
    remark
  } = props.config

  return (
    <React.Fragment>
      {!title ? null : <h2>{title}</h2>}
      {!intro ? null : <p className="form__intro">{intro}</p>}
      {!remark ? null : <div className="form__remark">{remark}</div>}
      {errorMessages}
      {parts}
      {submitButton}
    </React.Fragment>
  )
}

Step.propTypes = {
  config: PropTypes.object.isRequired
}

export default Step


// WEBPACK FOOTER //
// ./src/components/FormTemplates/Step.js